const e2eUsers = [
  'user_34ninADkucwkReerDv0ukwG7HMn', // E2E test user
  'user_2vEMCXP8WxlM7PHq13cUsbc1oBu', // Cypress / dev
  'ape2e@sugarcanetech.com',
  'e2e@thisandthat.chat',
  'user_2YBrWJS9rHXXWZDZUVPGwIsulnv', // Google test user
  'user_2gA5OVf1d4UGdhNM6p7iqSzkiIp', // Steve Jobs test user
];

// engTeam should be for dev accuonts only since we want to ensure data integrity in prod
const engTeam = [
  'user_2frvooGG2Ph5BEPeQP7GQZCGjWn', // jeff@thisandthat.chat / dev
  'user_2uH7FGImp8rnJzogD4VGfUNUlMw', // jreynar@gmail.com / dev
  'user_2PbjjybTXiAMYJBbyIIMuuNyKyr', // Brunno @thisandthat.chat / dev
  'user_2x3DqMGMZfpMUWvReiI9fphKxol', // Fabricio @sugarcanetech.com / dev
  'user_2x3CwbgUJVAFEI6fRmgncgvrZjw', // William @sugarcanetech.com / dev
  'user_2ymRg2AgBsPNl9qQmxdkulo6xFl', // Mateus @sugarcanetech.com / dev
  'user_2yeC3xJn2GZFOs1Ckv2HnmHcxLv', // Matheus @sugarcanetech.com / dev
  'user_2ydzurnuHc5qUOS2CHU5Fftl3hl', // Lucca @sugarcanetech.com / dev
  'user_2q9wINXNhQEDNiqViwmB3ba9Lau', // Samuel / dev
];

const prodEngTeam = [
  'user_36kpIbPJocrVAYLM9DCjXabemRN', // lucca@sugarcanetech.com
  'user_38tovIyabpJItZLlUI6XSOKpsCu', // fabricio@sugarcanetech.com
  // 'user_34zYWrquQKNrPyoRJtvhATFzbHo', // brunno@sugarcanetech.com
  // 'user_33mqRAbpIVJPPro81NmYBD47L2D', // brunno@thisandthat.chat
  'user_38LN66xr8YQHeINin80YgfcLYj7', // brunnoromerotenorio@gmail.com
  'user_38wI6hqxoZH414kESG5ay7fVPUL', // matt.goulart3003@gmail.com
  // 'user_33WGZW0EOjTr4TRvUjpvGOviqGt', // jeff@thisandthat.chat
  'user_35w7jqg7Nntoj6QcH93RmUksfrK', // jreynar@gmail.com
  'user_3CJGMkpufYGtwmZyWkU87HRI9w2', // matheus@sugarcanetech.com
  'user_3Bz5V1zRI3ozDOGrKuPC6vWBjMS', // matheus.rezende@sugarcanetech.com
  'user_3H6EYCRdUcMIhl2vs4UoT3fRGc9', // wesley.sanches@sugarcanetech.com
];

// Emails belonging to engineering / company staff. Funnel and other
// customer-facing metrics treat these accounts as non-customers.
const internalTeamEmails = [
  //'e2eUsers',
  //'ape2e@sugarcanetech.com',
  //'e2e@thisandthat.chat',
  //' engTeam',
  'arti@thisandthat.chat',
  'rafe@thisandthat.chat',
  'raksha@thisandthat.chat',
  'r2hrconsultancy@gmail.com',
  'jeff@thisandthat.chat',
  'jreynar@gmail.com',
  'brunno@thisandthat.chat',
  'fabricio@sugarcanetech.com',
  'william@sugarcanetech.com',
  'williampaivabusiness@gmail.com',
  'mateus@sugarcanetech.com',
  'matheus@sugarcanetech.com',
  'matheus.rezende@sugarcanetech.com',
  'matheus.rezendevr@gmail.com',
  'wesley.sanches@sugarcanetech.com',
  'lucca@sugarcanetech.com',
  'gustavo@sugarcanetech.com',
  'anna@sugarcanetech.com',
  'naresh@thisandthat.chat',
  'dylan@thisandthat.chat',
  'caroline@thisandthat.chat',
  'brunno@sugarcanetech.com',
  'brunnoromerotenorio@gmail.com',
  'matt.goulart3003@gmail.com',
  'gerald@impactbrixton.com',
  'gerald@thisandthat.chat',
  'e2e@thisandthat.chat',
  'williampaivabet@outlook.com',
  'fabriciodev77@gmail.com',
  'webookspaceaws@gmail.com',
  'jeff@erdoslabs.com',
  'nareshmahendhar19.uk@gmail.com',
  'rafeoffer@gmail.com',
  'rafe@sofarsounds.com',
  'reporting@loudspeakermarketing.com',
  'xavierrayara06@gmail.com',
  'luccarebtoledo@gmail.com',
];

// Account-only signups created to exercise flows (not engineer accounts).
// Excluded from funnel metrics alongside internalTeamEmails so the funnel
// reflects real customer behaviour. webookspaceaws@gmail.com and
// reporting@loudspeakermarketing.com are intentionally NOT duplicated here —
// they already live in internalTeamEmails above.
const funnelTestAccountEmails = [
  'oauthtestvsr@gmail.com',
  'producttrial987654321@gmail.com',
  'cwsqer02@gmail.com',
  'linuxxx@sudomail.com',
  'mimiki5825@eubonus.com',
  'cerseistone.172447@gmail.com',
  'xavierrayara06@gmail.com',
];

const team = [
  ...engTeam,
  ...e2eUsers,
  ...prodEngTeam,
  'user_33RSNx1P7FzSH4LHBsU7KjEF2MG', // anna@sugarcanetech.com / prod
  'user_33oMObrcexG0W4dqdhJvcjLG8Yd', // gerald@impactbrixton.com / prod
  'user_33VfCQkVdg5HibtwXU63Uqzaxwp', // gerald@thisandthat.chat / prod
];

export const isEngTeamMember = (userId: string) => engTeam.includes(userId);

export const isProdEngTeamMember = (userId: string) =>
  prodEngTeam.includes(userId);

export const isInternalTeamMemberByEmail = (email: string) =>
  internalTeamEmails.includes(email.toLowerCase());

/**
 * Single source of truth for "should this user be excluded from the funnel /
 * customer-quality metrics?". Returns true for engineers, company staff, and
 * known test accounts. Callers must use this helper rather than touching the
 * underlying lists directly so the union stays consistent across resolvers.
 */
export const isExcludedFromFunnel = (email: string): boolean =>
  isInternalTeamMemberByEmail(email) ||
  funnelTestAccountEmails.includes(email.toLowerCase());

/**
 * Sentinel value the auto-annotation writes to `HTUserFunnel.ManualSource`
 * when a known internal / test-account user deletes their account.
 * Matched (case-insensitively) by `isManualSourceExcludedFromFunnel`.
 */
export const FUNNEL_TEST_ANNOTATION = 'Test';

// manualSource values that mark a funnel row as "exclude from customer
// metrics". Operator types one of these in the inline editor on the admin
// funnel page when they recognize a row as an internal test account — useful
// especially for deleted accounts where the email is no longer available to
// match against funnelTestAccountEmails.
const funnelExcludeManualSources = [
  'test',
  'internal test',
  'internal',
  'reconnected',
];

/**
 * True if the manualSource string is a sentinel that means "exclude from
 * funnel metrics". Case-insensitive; trims whitespace. Distinct from
 * `isExcludedFromFunnel`, which is email-based — the two are independent
 * exclusion mechanisms and callers should be free to use one without the
 * other.
 */
export const isManualSourceExcludedFromFunnel = (
  manualSource: string | null | undefined,
): boolean => {
  if (!manualSource) return false;
  return funnelExcludeManualSources.includes(manualSource.trim().toLowerCase());
};

export const isTeamMember = (userId: string) => team.includes(userId);

export const isE2EUser = (userId: string) => e2eUsers.includes(userId);

export const isInternalAccount = ({
  userId,
  email,
}: {
  userId?: string;
  email?: string;
}) =>
  (!!userId && isTeamMember(userId)) ||
  (!!email && isExcludedFromFunnel(email));
